import { get } from "@insite/client-framework/Services/ApiService";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {
    ProductCollectionModel,
} from "@insite/client-framework/Types/ApiModels";


const productsUrl = "/api/v2/products";

export function getProductCollectionV2WithSubCategoriesOption(parameter: GetProductCollectionApiV2Parameter) {
    if(parameter.categoryId){
        const specialParameter = parameter as GetProductCollectionApiV2ParameterWithSubcategoriesOption;
        specialParameter.includeProductsInSubcategories = true;
        return get<ProductCollectionModel>(productsUrl, specialParameter);
    }
    else{
        return get<ProductCollectionModel>(productsUrl, parameter);
    }
}

export interface GetProductCollectionApiV2ParameterWithSubcategoriesOption extends GetProductCollectionApiV2Parameter {
    includeProductsInSubcategories?: boolean;
}

